<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('addToEndpoints') >= 0,
        'last-active': opened.indexOf('addToEndpoints') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEndpointAddConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="addToEndpoints()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("priraditKeSkupine") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="devices">
          {{ $t("priradit") }} {{ devices.length }}
          {{
            $filters.inflection(
              devices.length,
              $t("inflection_priradit_1_Skupina"),
              $t("inflection_priradit_2_4_Skupina"),
              $t("inflection_priradit_5_Skupina")
            )
          }}
          {{ $t("kEndpointu") }}
        </h2>
      </div>
      <FormSelectMultiple
        :items="loadedEndpoints"
        :value="selectedEndpoints"
        item-text="custDestName"
        item-value="custDestId"
        :label="$t('pripojitKEndpointu')"
        :placeholder="$t('vyberteEndpoint')"
        side-box
        @change="selectedEndpoints = $event"
      />
    </div>
    <div
      :class="{
        opened: opened.indexOf('newEndpoint') >= 0,
        'last-active': opened.indexOf('newEndpoint') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEndpointConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="createEndpoint()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("vytvoritRoutovaciSkupinu") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("novyEndpoint") }}</h2>
      </div>

      <NewEndpointFormFields
        :endpoint="newEndpoint"
        :errors="errors"
        :opened="opened"
        @close-box="closeBox"
        @open-box="openBox"
      />
    </div>
    <SaveConfirmationModal
      :opened="openedEndpointAddConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEndpointAddConfirmation"
      @no="closeBox('addToEndpoints')"
      @yes="addToEndpoints()"
    />
    <SaveConfirmationModal
      :opened="openedEndpointConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEndpointConfirmation"
      @no="closeBox('newEndpoint')"
      @yes="createEndpoint()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import NewEndpointFormFields from "@/components/modals/endpoints/NewEndpointFormFields.vue"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    FormSelectMultiple,
    NewEndpointFormFields,
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    tags: Array,
    devices: Array,
    opened: Array
  },
  emits: ["updateItems", "closeBox", "openBox"],
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      loadedEndpoints: [],
      selectedEndpoints: [],
      groupsOpened: false,
      parametersTagsOpened: false,
      parametersOpened: false,
      selectedParameters: [],
      tagsOpened: false,
      selectedEndpointTags: [],
      groupTags: [],
      writtenEndpointTags: "",
      newEndpoint: {
        projectId: "",
        custDestName: "",
        custDestDescription: "",
        custDestParameters: {},
        custDestEnabled: true,
        transformationId: null
      },
      openedEndpointAddConfirmation: false,
      openedEndpointConfirmation: false,
      errors: {
        device: "",
        group: ""
      },
      selectEndpointVisible: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  computed: {
    isEndpointValid() {
      if (!this.newEndpoint.protocol) {
        return false
      }

      if (this.newEndpoint.protocol === "HTTP") {
        return this.newEndpoint.custDestName && this.newEndpoint.custDestParameters.url
      }

      if (this.newEndpoint.protocol === "MQTT") {
        return this.newEndpoint.custDestName && this.newEndpoint.custDestParameters.address
      }

      return false
    },
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    project() {
      if (this.project && this.opened.indexOf("addToEndpoints") > -1) {
        this.loadEndpoints()
        this.setProject()
      }
    },
    writtenEndpointTags() {
      this.createTagsArray()
    },
    opened() {
      if (this.opened.indexOf("addToEndpoints") > -1) {
        this.loadEndpoints()
      }
    }
  },
  mounted() {
    if (this.project) {
      this.setProject()
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.emptyValues()
        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    setProject() {
      this.newEndpoint.projectId = this.project.projectId
    },
    loadEndpoints() {
      axios
        .get(process.env.VUE_APP_API + "/http/endpoints?search=" + this.project.projectId + "&limit=1000", {})
        .then((result) => {
          this.loadedEndpoints = result.data.data.filter(
            (endpoint) =>
              !this.devices.some((device) =>
                device.endpointsShortlist.map((e) => e.custDestId).includes(endpoint.custDestId)
              )
          )
        })
        .catch(() => {})
    },
    addRemoveEndpoint(endpoint) {
      if (this.selectedEndpoints.indexOf(endpoint) == -1) {
        this.selectedEndpoints.push(endpoint)
      } else {
        this.selectedEndpoints.splice(this.selectedEndpoints.indexOf(endpoint), 1)
      }
    },
    addRemoveParameter(parameter) {
      if (this.selectedParameters.indexOf(parameter) == -1) {
        this.selectedParameters.push(parameter)
      } else {
        this.selectedParameters.splice(this.selectedParameters.indexOf(parameter), 1)
      }
    },
    addRemoveTag(tag) {
      if (this.writtenEndpointTags.indexOf(tag) == -1) {
        this.writtenEndpointTags += tag
      }
    },
    createTagsArray() {
      let written = this.writtenEndpointTags.split(",")
      let selected = []
      written.forEach((tag) => {
        let trimmed = tag.trim()
        selected.push(trimmed)
      })
      this.selectedEndpointTags = selected
    },
    addToEndpoints() {
      this.errorsToTranslate = []
      let promises = []
      this.selectedEndpoints.forEach((endpoint) => {
        this.devices.forEach((device) => {
          promises.push(
            axios
              .post(
                process.env.VUE_APP_API +
                  "/device-groups/" +
                  device.deviceGroupId +
                  "/endpoints/" +
                  endpoint.custDestId +
                  "/assign",
                {},
                {}
              )
              .then(() => {})
              .catch((error) => {
                this.errorsToTranslate.push(error.data)
              })
          )
        })
      })
      Promise.all(promises).then(() => {
        this.openedError = true
        this.emptyValues()
        this.$emit("updateItems")
        this.closeBox("addToEndpoints")
      })
    },
    async createEndpoint() {
      this.errorsToTranslate1 = []

      if (this.isEndpointValid) {
        const postUrl = `${process.env.VUE_APP_API}${
          this.newEndpoint.protocol === "HTTP" ? "/http/endpoints" : "/mqtt/gateways"
        }`

        try {
          const result = await axios.post(postUrl, this.newEndpoint)

          let groupId = result.data.custDestId

          let createdEndpoint = this.newEndpoint
          createdEndpoint.custDestId = groupId

          this.loadedEndpoints.push(createdEndpoint)
          this.selectedEndpoints.push(createdEndpoint)
          this.$emit("closeBox", "newEndpoint")
        } catch (e) {
          console.error(e)
        }
      } else {
        this.errors.group = this.$t("fillAllFieldsError")
      }
    },
    getAllTags() {
      this.groupTags = _(this.loadedEndpoints)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleEndpointAddConfirmation() {
      this.openedEndpointAddConfirmation = this.openedEndpointAddConfirmation ? false : true
    },
    toggleEndpointConfirmation() {
      this.openedEndpointConfirmation = this.openedEndpointConfirmation ? false : true
    },
    emptyValues() {
      this.selectedEndpoints = []
      this.groupsOpened = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
